/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Per_BoatsInputs */

const es_marketplace_seo_license_row_per_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Per_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motora hasta 15 m; vela hasta 20 m`)
};

const gl_marketplace_seo_license_row_per_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Per_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motora ata 15 m; vela ata 20 m`)
};

const en_marketplace_seo_license_row_per_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Per_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor up to 15 m; sail up to 20 m`)
};

/**
* | output |
* | --- |
* | "Motor up to 15 m; sail up to 20 m" |
*
* @param {Marketplace_Seo_License_Row_Per_BoatsInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_per_boats = /** @type {((inputs?: Marketplace_Seo_License_Row_Per_BoatsInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Per_BoatsInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_per_boats(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_per_boats(inputs)
	return es_marketplace_seo_license_row_per_boats(inputs)
});